import styled from 'react-emotion';
import { themeGet } from 'styled-system';

export const IconWrapper = styled('div')`
  position: absolute;
  top: 0;
  left: 15px;
`;

export const InputWrapper = styled('div')`
  position: relative;
  overflow: hidden;
  width: 100%;

  svg {
    fill: ${themeGet('colors.blueDarker')};
  }

  &[data-placement="column"] {
    svg {
      fill: ${themeGet('colors.greyLight')};

      path {
        stroke: ${themeGet('colors.grey')};
      }
    }

    input:focus {
      border-color: ${themeGet('colors.greyLight')};
    }
  }
`;

// @width
// @padding
// @box-shadow
export const Input = styled('input')`
  width: 100%;
  height: 40px;
  appearance: none;
  transition: all 0.1s ease-in;
  outline: none;
  border: none;
  word-wrap: break-word;
  white-space: normal;
  display: inline-block;
  padding-top: ${themeGet('space.1')}px;
  padding-bottom: ${themeGet('space.1')}px;
  padding-right: ${themeGet('space.4')}px;
  padding-left: ${themeGet('space.6')}px;
  font-size: 18px;
  color: ${themeGet('colors.blueDarker')};
  font-weight: 300;
  background: inherit;
  border: 1.5px solid ${themeGet('colors.greyLight')};
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(184, 194, 204, 0.25);

  &::placeholder {
    color: ${themeGet('colors.grey')};
    font-size: 14px;

    @media screen and (min-width: 40em) {
      font-size: 18px;
    }
  }

  &:focus {
    border: 1.5px solid ${themeGet('colors.blueDarker')};
  }
`;



// WEBPACK FOOTER //
// ../shop_main/components/searchbox/style.js